<app-header></app-header>
<main><router-outlet></router-outlet></main>
<app-footer></app-footer>

<a *ngIf="chat_button.enabled" (click)="openWhatsAppAndTrack()" class="whatsapp-button" target="_blank">
    <img src="./assets/img/png/wsMobileLogo.png" alt="WhatsApp">
    <span class="whatsapp-notification">1</span>
  </a>
